import { Lender } from '@1delta/lender-registry'

const LENDER_SHORT_NAMES: Record<string, string> = {
  [Lender.AAVE_V2]: 'Aave V2',
  [Lender.AAVE_V3]: 'Aave V3',
  [Lender.AURELIUS]: 'Aurelius',
  [Lender.AVALON]: 'Avalon',
  [Lender.AVALON_PUMPBTC]: 'Avalon pumpBTC',
  [Lender.COMPOUND_V2]: 'Comp. V2',
  [Lender.COMPOUND_V3_AERO]: 'Comp. AERO',
  [Lender.COMPOUND_V3_INSTITUTIONAL_USDC]: 'Comp. USDC (Inst.)',
  [Lender.COMPOUND_V3_USDBC]: 'Comp. USDBC',
  [Lender.COMPOUND_V3_USDC]: 'Comp. USDC',
  [Lender.COMPOUND_V3_USDCE]: 'Comp. USDC.e',
  [Lender.COMPOUND_V3_USDE]: 'Comp. USDe',
  [Lender.COMPOUND_V3_USDS]: 'Comp. USDS',
  [Lender.COMPOUND_V3_USDT]: 'Comp. USDT',
  [Lender.COMPOUND_V3_WBTC]: 'Comp. WBTC',
  [Lender.COMPOUND_V3_WETH]: 'Comp. WETH',
  [Lender.COMPOUND_V3_WSTETH]: 'Comp. wstETH',
  [Lender.EULER_V2]: 'Euler V2',
  [Lender.DOLOMITE]: 'Dolomite',
  [Lender.FLUID]: 'Fluid',
  [Lender.FLUX_FINANCE]: 'Flux',
  [Lender.GEARBOX_V3]: 'Gearbox V3',
  [Lender.GRANARY]: 'Granary',
  [Lender.HANA]: 'Hana',
  [Lender.INIT]: 'Init',
  [Lender.LAYERBANK_V3]: 'LayerBank V3',
  [Lender.LENDLE]: 'Lendle',
  [Lender.LENDOS]: 'lendOS',
  [Lender.MERIDIAN]: 'Meridian',
}

function formatUnderscoreString(input: string): string {
  const _in = input
    .replace('MORPHO_BLUE', 'MB')
    .replace(/^FLUID_/, 'Fluid ')
    .replace(/^GEARBOX_V3_/, 'Gearbox V3 ')
  return _in
    .split('_')
    .map((word, index) => {
      if (index === 0) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      }
      return word.toUpperCase()
    })
    .join(' ')
}

export function lenderShortName(lender: string): string {
  if (lender?.startsWith('FLUID')) return 'Fluid'
  if (lender?.startsWith('GEARBOX_V3')) return 'Gearbox V3'
  return LENDER_SHORT_NAMES[lender] ?? formatUnderscoreString(lender)
}
